"use client";

import { useTranslation } from "react-i18next";
import type { CalendarEvent } from "@content-os/types";
import { getStatusColor } from "./platform-colors";

interface StatusBarProps {
  events: CalendarEvent[];
}

export function StatusBar({ events }: StatusBarProps) {
  const { t } = useTranslation("calendar");
  const counts = {
    SCHEDULED: events.filter((e) => e.status === "SCHEDULED").length,
    PUBLISHED: events.filter((e) => e.status === "PUBLISHED").length,
    FAILED: events.filter((e) => e.status === "FAILED").length,
    CANCELLED: events.filter((e) => e.status === "CANCELLED").length,
  };

  return (
    <div className="flex items-center gap-4 px-4 py-2 border-t text-xs text-muted-foreground">
      {Object.entries(counts)
        .filter(([, count]) => count > 0)
        .map(([status, count]) => (
          <span key={status} className="flex items-center gap-1.5">
            <span
              className="h-2 w-2 rounded-full"
              style={{ backgroundColor: getStatusColor(status as any) }}
            />
            {count} {t(`status.${status}`, { defaultValue: status.charAt(0) + status.slice(1).toLowerCase() })}
          </span>
        ))}
      {events.length === 0 && <span>{t("statusBar.empty")}</span>}
    </div>
  );
}
